import i18n from '@/libs/i18n'
import { availableCountries } from '@/utils/location/phoneCodeCountries'
import { localize } from 'vee-validate'
import store from '@/store'

export const pointTypes = {
  data() {
    return {
      pointTypes: [
        {
          title: 'Target',
          slug: 'target',
          icon: 'CrosshairIcon',
          tooltip: 'somedesc',

        },
        {
          title: 'Intermediate',
          slug: 'intermediate',
          icon: 'MapPinIcon',
          tooltip: 'somedesc',
        },
        {
          title: 'Turn',
          slug: 'turn',
          icon: 'CompassIcon',
          tooltip: 'somedesc',
        },
      ],
    }
  },
}

export const servicesTypes = {
  data() {
    return {
      servicesTypes: [
      ],
    }
  },
}

export const serviceOptions = {
  categories: [
    {
      slug: 'home_master',
      title: 'Home master',
      icon: '',
      point_purposes: [
        {
          slug: 'plumber',
          title: 'Plumber',
        },
        {
          slug: 'electrician',
          title: 'Electrician',
        },
        {
          slug: 'repair_of_windows_and_doors',
          title: 'Repair of windows & doors',
        },
        {
          slug: 'installation_of_household_appliances',
          title: 'Installation of Household Appliances',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
    {
      slug: 'vehicle_repair',
      icon: '',
      title: 'Vehicle repair',
      point_purposes: [
        {
          slug: 'inspection',
          title: 'Inspection',
        },
        {
          slug: 'computer_diagnostics',
          title: 'Computer diagnostics',
        },
        {
          slug: 'engine',
          title: 'Engine',
        },
        {
          slug: 'body_work',
          title: 'Body work',
        },
        {
          slug: 'chassis',
          title: 'Chassis',
        },
        {
          slug: 'electronics',
          title: 'Electronics',
        },
        {
          slug: 'transmission',
          title: 'Transmission',
        },
        {
          slug: 'exhaust_system',
          title: 'Exhaust system',
        },
        {
          slug: 'painting_works',
          title: 'Painting works',
        },
        {
          slug: 'tire_fitting',
          title: 'Tire fitting',
        },
        {
          slug: 'repair_and_replacement_of_glass',
          title: 'Repair and replacement of glass',
        },
        {
          slug: 'installation_of_gas_cylinder_equipment',
          title: 'Installation of gas cylinder equipment',
        },
        {
          slug: 'air_conditioners',
          title: 'Air conditioners',
        },
        {
          slug: 'salon_care',
          title: 'Salon care',
        },
        {
          slug: 'motorcycle_repair',
          title: 'Motorcycle repair',
        },
        {
          slug: 'bicycle_repair',
          title: 'Bicycle repair',
        },
        {
          slug: 'repair_of_scooters',
          title: 'Repair of scooters',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
    {
      slug: 'construction_works',
      title: 'Construction works',
      icon: '',
      point_purposes: [
        {
          slug: 'brick_laying',
          title: 'Brick laying',
        },
        {
          slug: 'laying_tiles',
          title: 'Laying tiles',
        },
        {
          slug: 'plasterboard_works',
          title: 'Plasterboard works',
        },
        {
          slug: 'woodwork',
          title: 'Woodwork',
        },
        {
          slug: 'metal_work',
          title: 'Metal work',
        },
        {
          slug: 'roofing_works',
          title: 'Roofing works',
        },
        {
          slug: 'concrete_works',
          title: 'Concrete works',
        },
        {
          slug: 'boring',
          title: 'Boring',
        },
        {
          slug: 'welding_works',
          title: 'Welding works',
        },
        {
          slug: 'earthworks',
          title: 'Earthworks',
        },
        {
          slug: 'construction_of_houses',
          title: 'Construction of Houses',
        },
        {
          slug: 'construction_of_small_structures',
          title: 'Construction of small structures',
        },
        {
          slug: 'fences_and_gates_installation',
          title: 'Fences and gates installation',
        },
        {
          slug: 'industrial_mountaineering',
          title: 'Industrial mountaineering',
        },
        {
          slug: 'sorting_of_debris',
          title: 'Sorting of debris',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
    {
      slug: 'equipment_repair',
      title: 'Equipment repair',
      icon: '',
      point_purposes: [
        {
          slug: 'air_conditioners',
          title: 'Air Conditioners',
        },
        {
          slug: 'refrigerators_and_freezers',
          title: 'Refrigerators & Freezers',
        },
        {
          slug: 'washing_and_drying_machines',
          title: 'Washing & Drying machines',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
    {
      slug: 'transport_services',
      icon: '',
      title: 'Transport services',
      point_purposes: [
        {
          slug: 'freight_transportation',
          title: 'Freight transportation',
        },
        {
          slug: 'services_of_porters',
          title: 'Services of porters',
        },
        {
          slug: 'removal_of_construction_waste',
          title: 'Removal of construction waste',
        },
        {
          slug: 'transportation_of_furniture_and_equipment',
          title: 'Transportation of furniture and equipment',
        },
        {
          slug: 'intercity_transportation',
          title: 'Intercity transportation',
        },
        {
          slug: 'international_transportation',
          title: 'International transportation',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
    {
      slug: 'courier_services',
      icon: '',
      title: 'Courier services',
      point_purposes: [
        {
          slug: 'delivery_of_products',
          title: 'Delivery of products',
        },
        {
          slug: 'delivery_of_medicines',
          title: 'Delivery of medicines',
        },
        {
          slug: 'delivery_of_goods_from_the_online_store',
          title: 'Delivery of goods from the online store',
        },
        {
          slug: 'delivery_of_documents',
          title: 'Delivery of documents',
        },
        {
          slug: 'delivery_of_gifts',
          title: 'Delivery of gifts',
        },
        {
          slug: 'send_by_train_or_bus',
          title: 'Send by train or bus',
        },
        {
          slug: 'pick_up_and_send_by_mail',
          title: 'Pick up and send by mail',
        },
        {
          slug: 'other',
          title: 'Other',
        },

      ],
    },
    {
      slug: 'cleaning_services',
      icon: '',
      title: 'Cleaning services',
      point_purposes: [
        {
          slug: 'cleaning_of_apartments_and_houses',
          title: 'Cleaning Apartments & Houses',
        },
        {
          slug: 'cleaning_of_industrial_premises',
          title: 'Cleaning of industrial premises',
        },
        {
          slug: 'cleaning_of_surrounding_areas',
          title: 'Cleaning the surrounding areas',
        },
        {
          slug: 'disinfection_and_dry_cleaning_of_premises',
          title: 'Disinfection and dry cleaning of premises',
        },
        {
          slug: 'other',
          title: 'Other',
        },
      ],
    },
  ],
  closeReasons: [
    {
      key: 'request_completed',
      i18n: 'Request completed',
      stages: ['completed'],
      requiresAcceptedEvent: true,
      variant: 'success',
    },
    {
      key: 'request_non_actual',
      i18n: 'Request non actual',
      stages: ['close_before_completion'],
      variant: 'secondary',
    },
    {
      key: 'another',
      i18n: 'Another reason',
      stages: ['close_before_completion'],
      variant: 'secondary',
      requiresComment: false,
    },
  ],
  getCloseReasonTitle(key) {
    return serviceOptions.closeReasons
      .find(r => r.key === key)?.i18n || ''
  },
  getServiceCloseReasons() {
    return serviceOptions.closeReasons.filter(reason =>
      reason.stages.includes('close_before_completion'))
  },

  getServiceCompleteReasons() {
    return serviceOptions.closeReasons.filter(reason =>
      reason.stages.includes('completed'))
  },

  getPurposeTitle(slug) {
    if (!slug) return ''

    const key = `point.purpose.${slug}`
    const translation = i18n.t(key)

    // If translation not found, fallback to slug
    return translation !== key ? translation : slug
  },
  getTypeTitle(slug) {
    if (!slug) return ''

    const key = `point.type.${slug}`
    const translation = i18n.t(key)

    // If the translation returns the key itself, assume it's missing
    return translation !== key ? translation : slug
  },
  getTranslatedPointTypes(obj) {
    if (obj) {
      const newObj = JSON.parse(JSON.stringify(obj))
      newObj.map(option => {
        option.title = i18n.t(`point.type.${option.slug}`)
        return option
      })
      return newObj.sort((a, b) => a.title.localeCompare(b.title))
    }
    return obj
  },
  getTranslatedPointPurposes(obj) {
    if (obj) {
      const newObj = JSON.parse(JSON.stringify(obj))
      newObj.map(option => {
        option.title = i18n.t(`point.purpose.${option.slug}`)
        return option
      })
      return newObj.sort((a, b) => a.title.localeCompare(b.title))
      // return newObj
    }
    return obj
  },

}

export const serviceRequestProps = [
  'Look for specialists who speak your language',
  'Send service requests 24/7',
  'Minimise phone calls',
  'Plan the date and time of the work',
]

export const serviceOfferProps = [
  'Publish your services in multiple languages',
  'Accept service requests 24/7',
  'Minimise phone calls',
  'Plan your working day, week, month',
]
export  const advertServiceTypes = [
  'household',
  'climate',
  'home_master',
  'renovation',
  'labourers',
  'equipment_repair',
  'vehicle_repair',
  'cleaning',
  'delivery',
  'beauty',
  'medicine',
  'animals',
  'holidays',
  'rental',
]

  export const locales = () => {
  const localesList = [
    // {
    //   locale: 'fr',
    //   img: require('@/assets/images/flags/fr.png'),
    //   name: 'French',
    // },
    {
      locale: 'uk',
      img: require('@/assets/images/flags/uk.png'),
      name: 'Укр',
      label: 'uk',
    },
    {
      locale: 'en',
      img: require('@/assets/images/flags/en-gb.png'),
      name: 'Eng',
      label: 'en',
    },
    {
      locale: 'es',
      img: require('@/assets/images/flags/es.png'),
      name: 'Esp',
      label: 'es',
    },
    {
      locale: 'de',
      img: require('@/assets/images/flags/de.png'),
      name: 'Deu',
      label: 'de',
    },
    {
      locale: 'ru',
      img: require('@/assets/images/flags/ru.png'),
      name: 'Рус',
      label: 'ru',
    },

  ]
  const countriesList = availableCountries

  const getLocale = (locale)=>localesList.find(el=>el.locale===locale)

  const getLang = (lang)=>{
    if(!lang) return "?"
    const locale = getLocale(lang.toLowerCase())
    return locale?locale.name:getLang(i18n.locale)
  }
  const setLocale = (locale)=>{
    localStorage.setItem('locale', locale)
    localize(locale)
    i18n.locale = locale
    return locale
  }

    /**
     * Orders a list of available language objects based on a user's preferred browser languages.
     *
     * @param {Array<Object>} availableLocaleObjects - An array of locale objects (like baseLocalesList).
     * @param {string[]} [userBrowserLanguages=navigator.languages] - Optional: User's browser languages.
     * @returns {Array<Object>} A new array of locale objects, ordered by user preference.
     */
    function getOrderedLocaleObjects(availableLocaleObjects, userBrowserLanguages = navigator.languages) {
      const browserLanguages = Array.isArray(userBrowserLanguages) ? userBrowserLanguages : [];
      const orderedLocalesMap = new Map(); // Use a Map to preserve order and avoid duplicates

      // Create a temporary map for quick lookup of locale objects by their 'locale' code
      const localeMap = new Map(availableLocaleObjects.map(item => [item.locale, item]));

      // 1. Add locale objects based on browser preferences
      for (const browserLang of browserLanguages) {
        const shortBrowserLang = browserLang.split('-')[0]; // e.g., 'uk' from 'uk-UA'
        if (localeMap.has(shortBrowserLang)) {
          orderedLocalesMap.set(shortBrowserLang, localeMap.get(shortBrowserLang));
        }
      }

      // 2. Add any remaining locale objects from the original list
      // This maintains the original order for languages not matched by browser prefs.
      for (const localeObj of availableLocaleObjects) {
        if (!orderedLocalesMap.has(localeObj.locale)) { // Only add if not already added by browser prefs
          orderedLocalesMap.set(localeObj.locale, localeObj);
        }
      }

      return Array.from(orderedLocalesMap.values());
    }
  return {
    localesList,
    countriesList,
    getLang,
    setLocale,
    getOrderedLocaleObjects,
  }
}
export const NETWORK_OPTIONS = Object.freeze({
  twitter: {
    dataField: 'twitter',
    label: 'social.twitter.label',
    help: 'social.twitter.help',
    placeholder: 'https://x.com/username',
    icon: 'TwitterIcon',
    baseUrl: 'https://x.com/',
    allowedDomains: ['x.com', 'twitter.com'],
    className: 'network-list__button--twitter',
    buildFromHandle: value => `https://x.com/${value}`,
  },
  facebook: {
    dataField: 'facebook',
    label: 'social.facebook.label',
    help: 'social.facebook.help',
    placeholder: 'https://www.facebook.com/username',
    icon: 'FacebookIcon',
    baseUrl: 'https://www.facebook.com/',
    allowedDomains: ['facebook.com'],
    className: 'network-list__button--facebook',
    buildFromHandle: value => `https://www.facebook.com/${value}`,
  },
  instagram: {
    dataField: 'instagram',
    label: 'social.instagram.label',
    help: 'social.instagram.help',
    placeholder: 'https://www.instagram.com/username',
    icon: 'InstagramIcon',
    baseUrl: 'https://www.instagram.com/',
    allowedDomains: ['instagram.com'],
    className: 'network-list__button--instagram',
    buildFromHandle: value => `https://www.instagram.com/${value}`,
  },
  threads: {
    dataField: 'threads',
    label: 'social.threads.label',
    help: 'social.threads.help',
    placeholder: 'https://www.threads.com/@username',
    icon: 'AtSignIcon',
    baseUrl: 'https://www.threads.com/@',
    allowedDomains: ['threads.com', 'threads.net'],
    className: 'network-list__button--threads',
    buildFromHandle: value => `https://www.threads.com/@${value.replace(/^@/, '')}`,
  },
  linkedin: {
    dataField: 'linkedin',
    label: 'social.linkedin.label',
    help: 'social.linkedin.help',
    placeholder: 'https://www.linkedin.com/in/username',
    icon: 'LinkedinIcon',
    baseUrl: 'https://www.linkedin.com/in/',
    allowedDomains: ['linkedin.com'],
    className: 'network-list__button--linkedin',
    buildFromHandle: value => {
      if (/^(?:in|company|school|showcase)\//i.test(value)) {
        return `https://www.linkedin.com/${value}`
      }

      return `https://www.linkedin.com/in/${value}`
    },
  },
  youtube: {
    dataField: 'youtube',
    label: 'social.youtube.label',
    help: 'social.youtube.help',
    placeholder: 'https://www.youtube.com/@channel',
    icon: 'YoutubeIcon',
    baseUrl: 'https://www.youtube.com/@',
    allowedDomains: ['youtube.com', 'youtu.be'],
    className: 'network-list__button--youtube',
    buildFromHandle: value => `https://www.youtube.com/@${value.replace(/^@/, '')}`,
  },
  tiktok: {
    dataField: 'tiktok',
    label: 'social.tiktok.label',
    help: 'social.tiktok.help',
    placeholder: 'https://www.tiktok.com/@username',
    icon: 'MusicIcon',
    baseUrl: 'https://www.tiktok.com/@',
    allowedDomains: ['tiktok.com'],
    className: 'network-list__button--tiktok',
    buildFromHandle: value => `https://www.tiktok.com/@${value.replace(/^@/, '')}`,
  },
  site: {
    dataField: 'site',
    label: 'social.site.label',
    help: 'social.site.help',
    placeholder: 'https://example.com',
    icon: 'GlobeIcon',
    allowedDomains: null,
    className: 'network-list__button--site',
    buildFromHandle: null,
  },
})

export const messengers = () => {
  const messengersList = [
    {
      icon: require('@/assets/images/icons/viber-48.png'),
      name: 'Viber',
      slug: 'viber',
      link:'viber://pa?chatURI='
    },
    {
      icon: require('@/assets/images/icons/whatsapp-48.png'),
      name: 'WhatsApp',
      slug: 'whatsapp',
      link:'https://wa.me/'
    },
    {
      icon: require('@/assets/images/icons/telegram-48.png'),
      name: 'Telegram',
      slug: 'telegram',
      link:'https://t.me/'
    },

  ]

  return {
    messengersList,
  }
}
export const currency = () => {
  const DEFAULT_CURRENCY = 'EUR'

  const currencyList = [
    { currency: 'EUR', symbol: '€', countryCodes: ['GB', 'ES'], label: 'EUR' },
    { currency: 'USD', symbol: '$', countryCodes: ['US'], label: 'USD' },
    { currency: 'UAH', symbol: '₴', countryCodes: ['UA'], label: 'UAH' },
  ]

  // Build quick lookup maps once
  const byCode = currencyList.reduce((acc, item) => {
    acc[item.currency] = item
    return acc
  }, {})

  const isSupported = code => !!(code && byCode[code])

  const resolveCurrencyCode = (code) => (isSupported(code) ? code : DEFAULT_CURRENCY)

  const getUserCurrency = () => {
    const code = store.state.account?.user?.currency
    return resolveCurrencyCode(code)
  }

  const getGeoDataCurrency = () => {
    const code = store.state.user?.geoData?.currency
    return resolveCurrencyCode(code)
  }

  const getCountryCurrency = (countryCode) => {
    const code = countryCode || store.state.user?.geoData?.country_code || 'UA'
    const found = currencyList.find(item => item.countryCodes.includes(code))
    return found || byCode[DEFAULT_CURRENCY]
  }

  const getCurrencySymbol = (currencyCode) => {
    const code = currencyCode ? resolveCurrencyCode(currencyCode) : getCountryCurrency().currency
    return byCode[code]?.symbol || ''
  }

  const getCurrencies = () => currencyList.map(el => el.currency)

  return {
    getCountryCurrency,
    getCurrencySymbol,
    getCurrencies,
    getGeoDataCurrency,
    getUserCurrency,
    currencyList,
  }
}
export const event = {
  postStatuses: [
    {
      title: 'published',
      slug: 'published',
      icon: 'EyeIcon',
      class: 'success',
    },
    {
      title: 'archived',
      slug: 'archived',
      icon: 'ArchiveIcon',
      class: 'dark',
    },
  ],

  withdrawReasons: {
    busy: 'Too busy',
    another: 'Another reason',
  },

  getDeclineReasonTitle(val) {
    if (val === 'another_proposal_accepted') {
      return i18n.t('Another proposal accepted')
    }

    const reason = serviceOptions.closeReasons.find(item => item.key === val)
    return i18n.t(reason?.i18n || '')
  },

  getWithdrawReasonTitle(val) {
    return i18n.t(event.withdrawReasons[val] || '')
  },

  getWithdrawReasons() {
    return Object.keys(event.withdrawReasons).reduce((acc, key) => {
      acc[key] = i18n.t(event.withdrawReasons[key])
      return acc
    }, {})
  },

  getDeclineReasons() {
    return serviceOptions.closeReasons
      .filter(reason => reason.key !== 'request_completed')
      .reduce((acc, reason) => {
        acc[reason.key] = i18n.t(reason.i18n)
        return acc
      }, {
        another_proposal_accepted: i18n.t('Another proposal accepted'),
      })
  },
}

export const postStatuses = {
  data() {
    return {
      postStatuses: [
        {
          title: 'draft',
          slug: 'draft',
          icon: 'EyeOffIcon',
          icon_visibility: 'EyeOffIcon',
          class: 'secondary',
        },
        {
          title: 'published',
          slug: 'published',
          icon: 'BookOpenIcon',
          icon_visibility: 'EyeIcon',
          class: 'success',
        },
        {
          title: 'archived',
          slug: 'archived',
          icon: 'ArchiveIcon',
          icon_visibility: 'EyeOffIcon',
          class: 'secondary',
        },
        {
          title: 'closed',
          slug: 'closed',
          icon: 'BookIcon',
          icon_visibility: 'EyeOffIcon',
          class: 'secondary',
        },
        {
          title: 'incomplete',
          slug: 'incomplete',
          icon: 'AlertTriangleIcon',
          icon_visibility: 'EyeOffIcon',
        },
      ],
    }
  },
}
export const pointOwnerOptions = Object.freeze([
  { title: 'Own',                 slug: 'own',             icon: 'UserIcon',  class: 'light-secondary' },
  { title: 'On Behalf',           slug: 'onBehalf',        icon: 'UsersIcon', class: 'light-secondary' },
  { title: 'On Behalf. Managed',  slug: 'onBehalfManaged', icon: 'UsersIcon', class: 'light-primary'  },
])

export const ALLOWED_TAGS = [
      'b', 'i', 'em', 'strong', 'u', 's', 'br',
      'p', 'ul', 'ol', 'li', 'blockquote', 'h5','span'
    ]
export const _ = null
